// The dialog to show when the user attempts to exit the web builder.
export enum ExitDialogTypeEnum {
  // The default exit dialog.
  DEFAULT = 'default',
  // The exit dialog that is shown when the web builder was launched from a Bitmoji Fashion Unlockable.
  // Warns the user that the Unlockable item won't be saved to their closet.
  UNLOCKABLE = 'unlockable',
}
